import { useLayoutEffect } from 'react';
import { AccountDataConsumer } from './accountData';
import Intercom from '@intercom/messenger-js-sdk';
import { boot } from "@intercom/messenger-js-sdk";
export function IntercomProvider() {
    const [accountDataConsumer] = AccountDataConsumer();
    const accountData = accountDataConsumer?.detail || {};
    const userName = accountData.full_name || `${accountData.first_name || ''} ${accountData.last_name || ''}`.trim() || undefined;
    const userEmail = accountData.email;

    useLayoutEffect(() => {

        // Flatten all attributes
        window.intercomSettings = {
            app_id: "nm7gmk21",
            hide_default_launcher: true,
            email: userEmail,
            user_id: accountData.id,
            name: userName,
            profileLink: "https://www.google.com",
            is_customer: true,
            is_barber: false,
            phone: "123213213213",
            phone_number: "123213213213",
            PhoneNumber: "213232"
        };

        const initIntercom = () => {
            const w = window;
            const ic = w.Intercom;

            if (typeof ic === "function") {
                ic("reattach_activator");
                ic("update", {
                    ...w.intercomSettings,
                    user_id: accountData.id
                });
            } else {
                const d = document;
                const i = function () { i.c(arguments); };
                i.q = [];
                i.c = function (args) { i.q.push(args); };
                w.Intercom = i;

                const l = function () {
                    const s = d.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = `https://widget.intercom.io/widget/${w.intercomSettings?.app_id}`;
                    const x = d.getElementsByTagName("script")[0];
                    x.parentNode?.insertBefore(s, x);
                };

                l();
            }
        };

        initIntercom();

        // MutationObserver to auto-hide launcher forever
        const observer = new MutationObserver(() => {
            const launcher = document.querySelector('.intercom-launcher');
            if (launcher) launcher.style.display = 'none';
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
            observer.disconnect();
        };
    }, [userName]);

    return null;
}
